import getEnergyLabelLink, { isOldEnergyLabel } from "./energy-label-link";

const useEnergyLabelLink = (babelProdotto, LANG, config) => {
  const { energyLabelCav, manuals, lineId, pageLine } = babelProdotto;
  const isOldLine = isOldEnergyLabel(config.isElMarket, lineId);
  const isNewEnergyLabelEu = pageLine?.docConfiguration.includes("new energy label (en)");
  const isNewEnergyLabelUk = pageLine?.docConfiguration.includes("new energy label (uk)");
  const isEnergyLabel = pageLine?.docConfiguration.includes("energy label");

  const check8815 =
    (isOldLine || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8815 && item?.filename?.startsWith("http"));
  const check8816 =
    (!isOldLine || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8816 && item?.filename?.startsWith("http"));
  const check8825 =
    (isOldLine || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8825 && item?.filename?.startsWith("http"));
  const check8826 =
    (!isOldLine || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8826 && item?.filename?.startsWith("http"));
  const manual8815 = manuals?.find(
    (item) => item?.type === 8815 && item?.filename?.startsWith("http")
  )?.filename;
  const manual8816 = manuals?.find(
    (item) => item?.type === 8816 && item?.filename?.startsWith("http")
  )?.filename;
  const manual8825 = manuals?.find(
    (item) => item?.type === 8825 && item?.filename?.startsWith("http")
  )?.filename;
  const manual8826 = manuals?.find(
    (item) => item?.type === 8826 && item?.filename?.startsWith("http")
  )?.filename;

  let energyLabelCavLink;

  if (!(energyLabelCav > 0) && check8815 && check8816 && (lineId === 666 || lineId === 17)) {
    energyLabelCavLink = [
      {
        link: manual8815,
      },
      {
        link: manual8816,
      },
    ];
  } else if (check8815 && !(energyLabelCav > 0)) {
    energyLabelCavLink = [
      {
        link: manual8815,
      },
    ];
  } else if (check8816 && !(energyLabelCav > 0)) {
    energyLabelCavLink = [
      {
        link: manual8816,
      },
    ];
  } else if (!(energyLabelCav > 0) && lineId !== 666 && lineId !== 17) {
    energyLabelCavLink = [
      {
        link: getEnergyLabelLink(babelProdotto, LANG, config, 0),
      },
    ];
  } else if (energyLabelCav > 0) {
    const res = [];
    for (let index = 0; index < energyLabelCav; index++) {
      if (lineId !== 666 && lineId !== 17) {
        res.push({
          link: check8815
            ? manual8815
            : check8816
            ? manual8816
            : getEnergyLabelLink(babelProdotto, LANG, config, index),
        });
      } else if (check8815 || check8816) {
        res.push({
          link: check8815 ? manual8815 : manual8816,
        });
      }
    }
    energyLabelCavLink = res;
  }

  if (isNewEnergyLabelUk && lineId !== 666 && lineId !== 17) {
    return check8825
      ? manual8825
      : check8826
      ? manual8826
      : getEnergyLabelLink(babelProdotto, LANG, config);
  } else if (isNewEnergyLabelUk && (check8825 || check8826)) {
    return check8825 ? manual8825 : manual8826;
  } else if ((isNewEnergyLabelEu || isEnergyLabel) && energyLabelCavLink?.length > 0) {
    return energyLabelCavLink?.[0]?.link;
  } else return "";
};

export default useEnergyLabelLink;
